import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SubscriptionState {
  id: number | null;
  user_id: number | null;
  plan: string | null;
  billing_type: string | null;
  starts_at: string | null;
  ends_at: string | null;
  is_active: boolean;
  is_expired: boolean;
  is_trial_plan: boolean;
  is_basic_plan: boolean;
  is_plus_plan: boolean;
  is_pro_plan: boolean;
  is_monthly_billing: boolean;
  is_half_yearly_billing: boolean;
  is_yearly_billing: boolean;
  is_load: boolean;
  role: string | null;
}

const initialState: SubscriptionState = {
  id: null,
  user_id: null,
  plan: null,
  billing_type: null,
  starts_at: null,
  ends_at: null,
  is_active: false,
  is_expired: false,
  is_trial_plan: false,
  is_basic_plan: false,
  is_plus_plan: false,
  is_pro_plan: false,
  is_monthly_billing: false,
  is_half_yearly_billing: false,
  is_yearly_billing: false,
  is_load: false,
  role: null
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    loadSubscription: (state, action: PayloadAction<Partial<SubscriptionState>>) => {
      Object.assign(state, action.payload);
      state.is_load = true;
    },
    clearSubscription: (state) => {
      Object.assign(state, initialState);
    },
    updateSubscription: (state, action: PayloadAction<Partial<SubscriptionState>>) => {
      Object.assign(state, action.payload);
    },
    loadSubscriptionStatusOnly: (state) => {
      state.is_load = true;
    },
  },
});

export const { loadSubscription, clearSubscription, updateSubscription,loadSubscriptionStatusOnly } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
